export { NileInlineSidebarItemBody } from './nile-inline-sidebar-item-body';